const rank = {
  name: '',
  title: '',
  rank: 0,
}

const progressTrack = {
  name: '',
  uuid: '',
  rank: rank
}

export default { progressTrack, rank };
